import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8000';

const socket = io(SOCKET_URL, {
  transports: ['websocket'],
  autoConnect: true,
  path: '/socket.io',
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 30000,
  randomizationFactor: 0.5,
  timeout: 20000,
  auth: (cb) => {
    try {
      const u = JSON.parse(localStorage.getItem('usuario') || 'null');
      cb({ token: u?.token || '' });
    } catch (e) {
      cb({ token: '' });
    }
  },
});

// Eventos de depuración
socket.on('connect', () => {
  console.log('✅ Socket.IO conectado a:', SOCKET_URL);
});

socket.on('connect_error', (error) => {
  console.error('❌ Socket.IO error:', error.message);
});

socket.on('disconnect', (reason) => {
  console.log('🔌 Socket.IO desconectado:', reason);
});

export default socket;
